import type { RepositoryIndexingMode } from "@arti/shared-source-control/indexing/runMode";
import type { FC } from "react";

import {
  REPOSITORY_INDEXING_MODE_OPTIONS,
  resolveRepositoryModeLabel,
} from "../../utils/repositoryIndexingModes";

interface IndexingModeSelectorProps {
  disabled?: boolean;
  mode: RepositoryIndexingMode;
  onChange: (mode: RepositoryIndexingMode) => void;
}

export const IndexingModeSelector: FC<IndexingModeSelectorProps> = ({
  disabled = false,
  mode,
  onChange,
}) => (
  <div
    aria-label="Repository indexing mode"
    className="inline-flex min-w-0 border border-slate-300 dark:border-slate-700"
    role="group"
  >
    {REPOSITORY_INDEXING_MODE_OPTIONS.map((option) => {
      const selected = option.value === mode;
      return (
        <button
          key={option.value}
          type="button"
          className={[
            "min-w-0 border-r border-slate-300 px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.18em] transition-colors last:border-r-0",
            selected
              ? "bg-emerald-600 text-white dark:bg-emerald-500 dark:text-arti-background"
              : "bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white",
          ]
            .join(" ")
            .trim()}
          aria-pressed={selected}
          disabled={disabled}
          title={option.description}
          onClick={() => onChange(option.value)}
        >
          <span className="truncate">
            {resolveRepositoryModeLabel(option.value)}
          </span>
        </button>
      );
    })}
  </div>
);
